<!-- Backdrop -->
<div
  class="confirmation-dialog-backdrop"
  [class.confirmation-dialog-backdrop--visible]="isVisible"
  (click)="onBackdropClick($event)"
  aria-hidden="true">

  <!-- Dialog Panel -->
  <div
    #dialogPanel
    class="confirmation-dialog"
    [class.confirmation-dialog--visible]="isVisible"
    role="alertdialog"
    aria-modal="true"
    [attr.aria-labelledby]="'confirmation-dialog-title'"
    [attr.aria-describedby]="'confirmation-dialog-message'"
    tabindex="-1">

    <!-- Header: icon + title in a row -->
    <div class="confirmation-dialog__header">
      <div [class]="iconCircleClass">
        <lucide-icon [name]="iconName"></lucide-icon>
      </div>
      <h2 id="confirmation-dialog-title" class="confirmation-dialog__title">
        {{ title }}
      </h2>
    </div>

    <!-- Message -->
    <p id="confirmation-dialog-message" class="confirmation-dialog__message">
      {{ message }}
    </p>

    <!-- Item display name (shown when a specific item name is provided) -->
    @if (itemDisplayName) {
      <p class="confirmation-dialog__item-name">{{ itemDisplayName }}</p>
    }

    <!-- Secondary message (shown after item name when provided) -->
    @if (secondaryMessage) {
      <p class="confirmation-dialog__message">{{ secondaryMessage }}</p>
    }

    <!-- Actions -->
    <div class="confirmation-dialog__actions">
      <button
        type="button"
        class="confirmation-dialog__btn confirmation-dialog__btn--secondary"
        (click)="cancel()">
        {{ cancelText }}
      </button>
      <button
        type="button"
        class="confirmation-dialog__btn"
        [class.confirmation-dialog__btn--primary]="(confirmButtonVariant ?? (type !== 'danger' ? 'primary' : 'danger')) === 'primary'"
        [class.confirmation-dialog__btn--danger]="(confirmButtonVariant ?? (type !== 'danger' ? 'primary' : 'danger')) === 'danger'"
        (click)="confirm()">
        @if (actionIcon) {
          <lucide-icon [name]="actionIcon"></lucide-icon>
        }
        {{ confirmText }}
      </button>
    </div>
  </div>
</div>
